import { render, staticRenderFns } from "./SisSelect.vue?vue&type=template&id=6befe2f3"
import script from "./SisSelect.vue?vue&type=script&lang=js"
export * from "./SisSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports